import React from 'react';
import {
  Typography,
  TypographyVariants,
} from '@dealersocket/ds-ui-react/Typography';
import { Button } from '@dealersocket/ds-ui-react/Button';
import { Page } from '../shared/components/Page';
import { ChevronLeftCircleIcon } from '../shared/icons/chevron-left-circle-icon';
import { LandingPageUrl } from '../shared/constants';

export const LoginExpiredPage = () => {
  return (
    <Page>
      <Typography variant={TypographyVariants.H5} paragraph>
        Login Session Expired
      </Typography>
      <Typography variant={TypographyVariants.Body1} paragraph>
        We&apos;re sorry, your login session has expired.
      </Typography>
      <Button
        data-e2e="returnToLoginButton"
        onClick={() => window.location.replace(LandingPageUrl)}
      >
        <ChevronLeftCircleIcon />
        RETURN TO LOGIN
      </Button>
    </Page>
  );
};
